import React from 'react';
var RightNaviagtor = function () { return (React.createElement("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("rect", { x: "0.5", y: "0.5", width: "39", height: "39", rx: "19.5", fill: "white" }),
    React.createElement("rect", { x: "0.5", y: "0.5", width: "39", height: "39", rx: "19.5", stroke: "#D3D3D3" }),
    React.createElement("path", { d: "M18 24L22 20L18 16", stroke: "#282828", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); };
export default RightNaviagtor;
